'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ExternalContentCardSource = require('./ExternalContentCardSource');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ExternalContentCardSource).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }